<template>
    <div class="all-charges card fts-table-wrapper">
        <h3 class="all-charges-header">All charges</h3>
        <div class="charges-info-box">
            <div class="charges-box">
                <h4>{{currentMonthCharges}}</h4>
                <h5>Current Charges</h5>
            </div>
            <div class="charges-box">
                <h4>{{previousMonthCharges}}</h4>
                <h5>Previous Month Charges</h5>
            </div>
            <div class="charges-box threshold">
                <div class="info">
                    <h4>{{threshold}}</h4>
                    <h5>Threshold</h5>
                </div>
                <button v-if="suspended" @click="openSetThreshold()" class="edit-button">
                    <i class="fa fa-pencil"></i>
                </button>
            </div>
        </div>
        <div class="filter-row">
            <div class="left-side">
                <input type="text" class="form-control"  v-model="filter" v-on:keyup="searchKeyUp" v-on:keydown="searchKeyDown" placeholder="Search" />
                <div class="fts-dropdown" v-click-outside="closeDropdownCompany">
                    <div :class="['dropdown-control', openedDropdownCompany ? 'straight-border' : '']" @click="openCloseDropdownCompany">
                        <span class="dropdown-title" v-if="selectedCompanies.length == 0">{{dropdownTitleCompany}}</span>
                        <div v-else class="selected-list">
                            <div v-for="selected in displaySelectedCompanies" class="selected-item">
                                {{selected.label}}
                                <i class="fa fa-times-circle" @click.stop="deselectOptionCompanies(selected)"></i>
                            </div>
                        </div>
                        <span class="count-hidden">
                            {{countHiddenCompanies}}
                        </span>
                        <i :class="['fa', openedDropdownCompany ? 'fa-caret-up' : 'fa-caret-down']"></i>
                    </div>
                    <div :class="['dropdown-list', openedDropdownCompany ? 'list-visible' : '']">
                        <div class="dropdown-search">
                            <i class="fa fa-search"></i>
                            <input v-model="searchedPhraseCompany" type="text" placeholder="Search" @keyup="searchPhraseCompanies"/>
                        </div>
                        <div class="dropdown-options">
                            <div class="dropdown-option">
                                <label class="dropdown-label" :for="'company-option0'" :option-selected="isAllRowSelected()">
                                    <input class="dropdown-checkbox" :id="'company-option0'" type="checkbox" :checked="isAllRowSelected()" @change="selectAllOptionCompany()">
                                    <span></span>
                                    <span class="option-content">Select All Companies</span>
                                </label>
                            </div>
                            <div class="dropdown-option" v-for="row in displayedCompanies">
                                <label class="dropdown-label" :for="'company-option' + row.value" :option-selected="row.selected">
                                    <input class="dropdown-checkbox" :id="'company-option' + row.value" type="checkbox" :checked="row.selected" @change="selectOptionCompany(row, null)">
                                    <span></span>
                                    <span class="option-content">{{row.label}}</span>
                                </label>
                            </div>
                        </div>
                        <div class="clear-box">
                            <button class="btn btn-light clear-btn" @click="clearCompaniesDropdown">Clear</button>
                        </div>
                    </div>
                </div>
                <button class="btn btn-primary filters-btn" @click="openFilters()">Filters</button>
            </div>
            <div class="size-page-wrapper text-right">
                <label for="size-page">Display:</label>
                <select v-on:change="sizePage" v-model="sortSettings.size" id="size-page" class="form-control custom-select">
                    <option value="40">40</option>
                    <option value="60">60</option>
                    <option value="80">80</option>
                    <option value="100">100</option>
                </select>
            </div>
        </div>
        <div class="fts-table table-responsive-sm">
            <table class="table b-table table-striped table-hover b-table-selectable b-table-select-multi fts-table">
                <thead role="rowgroup">
                <tr role="row">
                    <th role="columnheader" :aria-sort="setAreaSort(1)" @click="changeSort(1)">Date Occured</th>
                    <th role="columnheader" :aria-sort="setAreaSort(2)" @click="changeSort(2)">Company Name</th>
                    <th role="columnheader" :aria-sort="setAreaSort(3)" @click="changeSort(3)">Type</th>
                    <th role="columnheader" :aria-sort="setAreaSort(4)" @click="changeSort(4)">Amount</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="charge in chargesList">
                    <td>{{charge.issuedAt}}</td>
                    <td>{{charge.companyName}}</td>
                    <td>{{charge.type}}</td>
                    <td>$ {{charge.amountInUsd}}</td>
                </tr>
                </tbody>
            </table>
            <div class="fts-bottom-table fts-bottom-table-centered all-charges-nav">
                <nav v-if="paginationCount" class="table-navigation" aria-label="Page navigation example">
                    <Paginate :page-count="paginationCount" v-model="sortSettings.page" :click-handler="paginationControll" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'"></Paginate>
                </nav>
            </div>
            <div class="no-charges" v-if="loading == false && noCharges == true">
                <h2 class="text">You have no charges to display</h2>
            </div>
        </div>
        <div class="loader-charges-list" v-if="loading">
            <div class="loading-sims-inner">
                <div class="sk-wave">
                    <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                </div>

                <div class="text">
                    Charges list is updating...
                </div>
            </div>
        </div>
        <b-modal ref="filters" id="filters" hide-header hide-footer centered>
            <div class="columns">
                <div class="column type">
                    <h3>Type</h3>
                    <FTScheckbox v-model="type.auto" :label="'Auto'"></FTScheckbox>
                    <FTScheckbox v-model="type.manual" :label="'Manual'"></FTScheckbox>
                    <p v-if="errorMsgs.types != ''" class="error-msg">{{errorMsgs.types}}</p>
                </div>
                <div class="column dates">
                    <h3>Time period</h3>
                    <div class="radio-box">
                        <input type="radio" id="monthDate" name="date-option" v-model="dateOption" value="1">
                        <label for="monthDate"><span>Month</span></label>
                    </div>
                    <select :disabled="dateOption != 1" v-model="offset" class="form-control custom-select">
                        <option v-for="offset of billingPeriods" :value="offset.offset">{{offset.name}}</option>
                    </select>
                    <div class="radio-box">
                        <input type="radio" id="date-range" name="date-option" v-model="dateOption" value="2">
                        <label for="date-range"><span>Date range</span></label>
                    </div>
                    <date-picker v-model="startDate" :disabled="dateOption != 2" valueType="format" :lang="langDataPicker" :first-day-of-week="1"></date-picker>
                    <date-picker v-model="endDate" :disabled="dateOption != 2" valueType="format" :lang="langDataPicker" :first-day-of-week="1"></date-picker>
                    <p v-if="errorMsgs.dates != ''" class="error-msg">{{errorMsgs.dates}}</p>
                </div>
                <div class="column amount">
                    <h3>Amount</h3>
                    <input type="number" v-model="amountFrom" placeholder="$ From">
                    <input type="number" v-model="amountTo" placeholder="$ To">
                    <p v-if="errorMsgs.amountFrom != ''" class="error-msg">{{errorMsgs.amountFrom}}</p>
                    <p v-if="errorMsgs.amountTo != ''" class="error-msg">{{errorMsgs.amountTo}}</p>
                </div>
            </div>
            <div class="control-bar">
                <div class="left-side">
                    <button class="btn btn-light" @click="setDefaultFilter()">Set Default</button>
                </div>
                <div class="right-side">
                    <button class="btn btn-light" @click="cancelFilters()">Cancel</button>
                    <button class="btn btn-primary" @click="setFilters()">Apply</button>
                </div>
            </div>
        </b-modal>
        <b-modal ref="setThreshold" id="setThreshold" centered hide-footer hide-header>
            <i class="fa fa-credit-card"></i>
            <h3>Threshold</h3>
            <p>Set new threshold value</p>
            <input type="number" v-model="thresholdValue">
            <div class="buttons-row">
                <button class="btn btn-light" @click="cancelSetThreshold()">Cancel</button>
                <button class="btn btn-success" @click="changeThreshold()">Confirm</button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import Axios from 'axios'
    import globalStore from '../../variables'
    import Paginate from 'vuejs-paginate'
    import FTScheckbox from "../../ftsComponents/FTScheckbox";
    import DatePicker from "vue2-datepicker";
    export default {
        name: "AllCharges",
        components: {
            FTScheckbox,
            Paginate,
            DatePicker
        },
        data() {
            return {
                chargesList: [],
                loading: false,
                noCharges: false,
                sortSettings: {
                    page: 1,
                    size: 40,
                    sort: 1,
                    desc: true
                },
                paginationCount: false,
                typingTimer: null,
                timeOutCompanies: null,
                search: '',
                filter: '',
                searchedPhraseCompany: '',
                openedDropdownCompany: false,
                displayedCompanies: [],
                displaySelectedCompanies: [],
                companiesList: [],
                selectedCompanies: [],
                countHiddenCompanies: null,
                dropdownTitleCompany: 'Companies',
                currentMonthCharges: '',
                previousMonthCharges: '',
                threshold: '',
                thresholdNumber: '',
                thresholdValue: 0,
                type: {
                    auto: true,
                    manual: true
                },
                dateOption: 1,
                billingPeriods: [],
                offset: 0,
                startDate: null,
                endDate: null,
                amountFrom: null,
                amountTo: null,
                langDataPicker: {
                    days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                    pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
                    placeholder: {
                        date: 'Select Date',
                        dateRange: 'Select Date Range'
                    }
                },
                initialFilters: {
                    type: {
                        auto: true,
                        manual: true
                    },
                    dateOption: 1,
                    offset: 0,
                    startDate: null,
                    endDate: null,
                    amountFrom: '',
                    amountTo: ''
                },
                errorMsgs: {
                    amountFrom: '',
                    amountTo: '',
                    dates: '',
                    types: ''
                },
                suspended: false
            }
        },
        methods: {
            getPagination() {
                let types = ''
                if (this.type.auto) {
                    types = '&types=AUTO'
                }
                if (this.type.manual) {
                    types = types + '&types=MANUAL'
                }

                let companyIDs = []

                for (let item in this.selectedCompanies) {
                    companyIDs.push(this.selectedCompanies[item]['value'])
                }

                companyIDs = companyIDs.length ? '&companyIds=' + companyIDs.join() : ''

                let dateRange = ''

                if (this.dateOption == 1) {
                    dateRange = '&offset=' + this.offset
                } else {
                    dateRange = '&dateFrom=' + this.startDate + '&dateTo=' + this.endDate
                }

                let amounts = ''
                if (this.amountFrom != '' && this.amountFrom != null) {
                    amounts = '&amountFrom=' + this.amountFrom
                }
                if (this.amountTo != '' && this.amountTo != null) {
                    amounts = amounts + '&amountTo=' + this.amountTo
                }

                Axios.get(globalStore.data.restApiUrl + '/billing-charges/page-count?page=' + this.sortSettings.page + '&sort=' + this.sortSettings.sort + '&size=' + this.sortSettings.size + '&desc=' + this.sortSettings.desc + companyIDs + types + dateRange + amounts + this.search)
                    .then(response => {
                        this.paginationCount = response.data
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Getting data error',
                            text: 'An error has occured during getting charges pagination value.',
                            duration: 5000,
                        })
                        console.log(error)
                    })
            },
            getCharges(resetPage) {
                this.loading = true
                this.noCharges = false
                if (resetPage) {
                    this.sortSettings.page = 1
                    this.getPagination()
                }

                let types = ''
                if (this.type.auto) {
                    types = '&types=AUTO'
                }
                if (this.type.manual) {
                    types = types + '&types=MANUAL'
                }

                let companyIDs = []

                for (let item in this.selectedCompanies) {
                    companyIDs.push(this.selectedCompanies[item]['value'])
                }

                companyIDs = companyIDs.length ? '&companyIds=' + companyIDs.join() : ''


                let dateRange = ''

                if (this.dateOption == 1) {
                    dateRange = '&offset=' + this.offset
                } else {
                    dateRange = '&dateFrom=' + this.startDate + '&dateTo=' + this.endDate
                }

                let amounts = ''
                if (this.amountFrom != '' && this.amountFrom != null) {
                    amounts = '&amountFrom=' + this.amountFrom
                }
                if (this.amountTo != '' && this.amountTo != null) {
                    amounts = amounts + '&amountTo=' + this.amountTo
                }

                Axios.get(globalStore.data.restApiUrl + '/billing-charges/list?page=' + this.sortSettings.page + '&sort=' + this.sortSettings.sort + '&size=' + this.sortSettings.size + '&desc=' + this.sortSettings.desc + companyIDs + types + dateRange + amounts + this.search)
                    .then(response => {
                        this.chargesList = response.data

                        for (let item of this.chargesList) {
                            item.amountInUsd = item.amountInUsd.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})
                        }
                        if (this.chargesList.length == 0) {
                            this.noCharges = true
                        }
                        this.loading = false
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Getting data error',
                            text: 'An error has occured during getting charges list.',
                            duration: 5000,
                        })
                        console.log(error)
                    })
            },
            changeSort(sortId) {
                if (sortId == this.sortSettings.sort) {
                    this.sortSettings.desc = !this.sortSettings.desc
                }
                this.sortSettings.sort = sortId
                this.getCharges(false)
            },
            setAreaSort(sortId) {
                if (sortId != this.sortSettings.sort) {
                    return 'none'
                } else if (sortId == this.sortSettings.sort && this.sortSettings.desc) {
                    return 'descending'
                } else if (sortId == this.sortSettings.sort && this.sortSettings.desc == false) {
                    return 'ascending'
                }
            },
            paginationControll(ev) {
                this.loading = true;
                this.sortSettings.page = ev;
                this.getCharges(false);
            },
            searchKeyUp() {
                clearTimeout(this.typingTimer)
                this.typingTimer = setTimeout(() => {
                    this.searchRow()
                }, 500)
            },
            searchKeyDown() {
                clearTimeout(this.typingTimer)
            },
            searchRow: function () {
                if (this.filter.length > 0) {
                    this.search = '&search=' + escape(this.filter);
                } else {
                    this.search = '';
                }
                this.getCharges(true);
            },
            sizePage() {
                this.getCharges(true);
            },
            openCloseDropdownCompany() {
                if (!this.openedDropdownCompany)
                    this.openedDropdownCompany = true;
                else
                    this.openedDropdownCompany = false;
            },
            closeDropdownCompany() {
                if (this.openedDropdownCompany)
                    this.openedDropdownCompany = false;
            },
            deselectOptionCompanies(option) {
                this.selectedCompanies = this.selectedCompanies.filter(item => {
                    return option.value != item.value
                })
                for (let item of this.companiesList) {
                    if (item.value == option.value) {
                        item.selected = false;
                    }
                }
                for (let item of this.displayedCompanies) {
                    if (item.value == option.value) {
                        item.selected = false;
                    }
                }

                if (this.selectedCompanies.length > 0) {
                    if (this.selectedCompanies.length == 1) {
                        this.countHiddenCompanies = ''
                    } else {
                        this.countHiddenCompanies = '...'
                    }
                } else {
                    this.countHiddenCompanies = ''
                }

                this.displaySelectedCompanies = this.selectedCompanies.slice(0,1);
                this.getChargesDropdown()
            },
            clearCompaniesDropdown() {
                this.companiesList.map(item => {
                    item.selected = false;
                })

                this.displayedCompanies.map(item => {
                    item.selected = false;
                })

                this.selectedCompanies = [];
                this.openedDropdownCompany = false;
                this.countHiddenCompanies = ''

                this.getChargesDropdown()
            },
            searchPhraseCompanies() {
                if (this.searchedPhraseCompany != '') {
                    this.displayedCompanies = this.companiesList.filter(item => {
                        return item.label.toLowerCase().indexOf(this.searchedPhraseCompany.toLowerCase()) != -1 ? item : null;
                    })
                } else {
                    this.displayedCompanies = this.companiesList;
                }
            },
            isAllRowSelected() {
                if (this.selectedCompanies.length == this.displayedCompanies.length) {
                    return true
                } else {
                    return false;
                }
            },
            selectAllOptionCompany() {
                let selectMode = this.selectedCompanies.length == this.displayedCompanies.length ? false : true
                for (let company in this.displayedCompanies) {
                    this.selectOptionCompany(this.displayedCompanies[company], selectMode)
                }
            },
            selectOptionCompany(option, selectOption) {
                if (selectOption == null) {
                    option.selected = !option.selected;
                    if (option.selected) {
                        this.selectedCompanies.push(option);
                    } else {
                        this.selectedCompanies = this.selectedCompanies.filter(item => {
                            return option.value != item.value
                        })
                    }
                } else if (selectOption == true) {
                    if (option.selected == false) {
                        option.selected = true
                        this.selectedCompanies.push(option);
                    }
                } else if (selectOption == false) {
                    if (option.selected == true) {
                        option.selected = false
                        this.selectedCompanies = this.selectedCompanies.filter(item => {
                            return option.value != item.value
                        })
                    }
                }

                if (this.selectedCompanies.length > 0) {
                    if (this.selectedCompanies.length == 1) {
                        this.countHiddenCompanies = ''
                    } else {
                        this.countHiddenCompanies = '...'
                    }
                } else {
                    this.countHiddenCompanies = ''
                }

                this.displaySelectedCompanies = this.selectedCompanies.slice(0,1);

                this.getChargesDropdown()
            },
            getCompaniesList() {
                Axios.get(`${globalStore.data.restApiUrl}/admin/accounts/essentials?page=1&size=1000&sort=2&desc=false`)
                    .then(response => {
                        this.companiesList = [];
                        for (let company of response.data) {
                            this.companiesList.push(
                                {
                                    value: company.companyId,
                                    label: company.companyName,
                                    selected: false
                                }
                            )
                        }
                        this.displayedCompanies = this.companiesList;
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Getting data error',
                            text: 'An error has occured during getting companies list.',
                            duration: 5000,
                        })
                        console.log(error)
                    })
            },
            getChargesDropdown() {
                clearTimeout(this.timeOutCompanies);

                this.timeOutCompanies = setTimeout(() => {
                    this.getCharges(true)
                }, 500)
            },
            getSummaryInfo() {
                Axios.get(globalStore.data.restApiUrl + '/billing-payment-suspension')
                    .then(response => {
                        this.currentMonthCharges = response.data.currentMonthCharges.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})
                        this.previousMonthCharges = response.data.previousMonthCharges.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})
                        this.threshold = response.data.threshold.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})
                        this.thresholdNumber = response.data.threshold
                        this.thresholdValue = response.data.threshold
                        this.suspended = response.data.suspended
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Getting data error',
                            text: 'An error has occured during getting charges summary info.',
                            duration: 5000,
                        })
                        console.log(error)
                    })
            },
            openFilters() {
                this.$refs['filters'].show()
            },
            openSetThreshold() {
                this.$refs['setThreshold'].show()
            },
            cancelFilters() {
                this.errorMsgs = {
                    amountFrom: '',
                    amountTo: '',
                    dates: '',
                    types: ''
                }
                this.type.auto = this.initialFilters.type.auto
                this.type.manual = this.initialFilters.type.manual
                this.dateOption = this.initialFilters.dateOption
                this.offset = this.initialFilters.offset
                this.startDate = this.initialFilters.startDate
                this.endDate = this.initialFilters.endDate
                this.amountFrom = this.initialFilters.amountFrom
                this.amountTo = this.initialFilters.amountTo
                this.$refs['filters'].hide()
            },
            cancelSetThreshold() {
                this.$refs['setThreshold'].hide()
                this.thresholdValue = this.thresholdNumber
            },
            getBillingPeriods() {
                Axios.get(globalStore.data.restApiUrl + '/billing-charges/months')
                    .then (response => {
                        this.billingPeriods = response.data
                    })
            },
            changeThreshold() {
                if (this.thresholdValue <= this.thresholdNumber) {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Incorrect Threshold value',
                        text: 'New threshold value must be bigger than current one.',
                        duration: 5000,
                    })
                    return false
                }
                Axios.post(globalStore.data.restApiUrl + '/billing-payment-suspension', {amount: this.thresholdValue})
                    .then(response => {
                        this.$refs['setThreshold'].hide()
                        this.getSummaryInfo()
                        globalStore.data.EventBus.$emit('refreshThreshold', true)
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Threshold value saved',
                            text: 'New threshold value has been saved.',
                            duration: 5000,
                        })
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Threshold value not saved',
                            text: 'An error has occured during saving new threshold value.',
                            duration: 5000,
                        })
                        console.log(error)
                    })
            },
            setDefaultFilter() {
                this.type.auto = true
                this.type.manual = true
                this.dateOption = 1
                this.offset = 0
                this.startDate = null
                this.endDate = null
                this.amountFrom = ''
                this.amountTo = ''
                this.getCharges(true)
                this.$refs['filters'].hide();
            },
            setFilters() {
                this.errorMsgs = {
                    amountFrom: '',
                    amountTo: '',
                    dates: '',
                    types: ''
                }
                let errorCount = 0
                if (this.amountFrom < 0 || this.amountTo < 0) {
                    this.errorMsgs.amountFrom = 'This value must he higher than zero'
                    errorCount++
                }
                if ((this.amountTo && this.amountFrom) && this.amountTo < this.amountFrom) {
                    this.errorMsgs.amountFrom = 'Second value must be higher than first one'
                    errorCount++
                }
                if (this.startDate && this.endDate && this.endDate < this.startDate) {
                    this.errorMsgs.dates = 'End date must be later than start date'
                    errorCount++
                }
                let today = new Date();
                if (this.dateOption == 2 && this.startDate && (new Date(this.startDate) > today)) {
                    this.errorMsgs.dates = 'Start date can not be from the future'
                    errorCount++
                }
                if (this.dateOption == 2 && this.endDate && (new Date(this.endDate) > today)) {
                    this.errorMsgs.dates = 'End date can not be from the future'
                    errorCount++
                }
                if (this.type.auto == false && this.type.manual == false) {
                    this.errorMsgs.types = 'At least one type must be selected'
                    errorCount++
                }

                if (errorCount > 0) {
                    return false
                }


                this.initialFilters.type.auto = this.type.auto
                this.initialFilters.type.manual = this.type.manual
                this.initialFilters.dateOption = this.dateOption
                this.initialFilters.offset = this.offset
                this.initialFilters.startDate = this.startDate
                this.initialFilters.endDate = this.endDate
                this.initialFilters.amountFrom = this.amountFrom
                this.initialFilters.amountTo = this.amountTo

                this.getCharges(true)
                this.$refs['filters'].hide();
            }
        },
        mounted() {
            this.getCharges(true);
            this.getCompaniesList();
            this.getSummaryInfo();
            this.getBillingPeriods();
        }
    }
</script>

<style src="spinkit/scss/spinkit.scss" lang="scss" />
<style lang="scss">
    .all-charges {
        display: flex;
        flex-direction: column;
        min-height: 700px;
        background-color: #fff;
        margin-bottom: 20px;
        padding-bottom: 0;
        .all-charges-header {
            margin: 20px;
            font-size: 14px;
        }
        .charges-info-box {
            display: flex;
            margin: 20px;
            .charges-box {
                width: 250px;
                padding: 20px;
                margin: 0 20px 0 0;
                background-color: #f2f2f2;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;
                border: 1px solid #c9cfd4;
                h4 {
                    margin: 0 0 8px;
                    font-size: 24px;
                    font-weight: 700;
                    &:before {
                        content: '$';
                        margin-right: 6px;
                    }
                }
                h5 {
                    margin: 0;
                    font-size: 14px;
                    font-weight: 400;
                }
                &.threshold {
                    display: flex;
                    justify-content: space-between;
                    padding: 3px;
                    .info {
                        padding: 17px 0 17px 17px;
                    }
                    .edit-button {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        height: 100%;
                        width: 75px;
                        color: #fff;
                        border-top-right-radius: 5px;
                        border-bottom-right-radius: 5px;
                        background-color: #0088ff;
                        border: none;
                        i {
                            margin: 0;
                        }
                    }
                }
            }
        }
        .filter-row {
            display: flex;
            justify-content: space-between;
            padding: 20px;
            border-top: 1px solid #c9cfd4;
            border-bottom: 1px solid #c9cfd4;
            .left-side {
                display: flex;
                .form-control {
                    width: 100%;
                    margin-right: 20px;
                }
                .fts-dropdown {
                    min-width: 250px;
                }
                .filters-btn {
                    margin-left: 20px;
                }
            }
            .text-right {
                display: flex;
                align-items: center;
                label {
                    margin: 0 10px 0 0;
                }
            }
        }

        .fts-table {
            position: relative;
            flex-grow: 1;
        }

        .all-charges-nav {
            position: initial;
        }

        .loader-charges-list,
        .no-charges {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;

            background-color: rgba(255, 255, 255, 0.7);

            display: flex;
            justify-content: center;
            align-items: center;
            align-content: center;

            .sk-wave {
                height: 60px;
                .sk-rect {
                    width: 3px;
                    background-color: #39c354;
                    border-radius: 4px;
                }
            }

            .text {
                margin-top: 20px;
                text-align: center;
                font-size: 15px;
                font-weight: 700;
            }
        }
    }
    #filters___BV_modal_outer_ {
        .modal-dialog {
            width: fit-content;
            max-width: none;
            #filters___BV_modal_body_ {
                padding: 0;

                .columns {
                    display: flex;
                    justify-content: space-between;

                    .column {
                        position: relative;
                        display: flex;
                        flex-direction: column;
                        padding: 20px;
                        border-right: 1px solid #dddddd;

                        h3 {
                            margin: 0 0 16px;
                            font-size: 15px;
                            font-weight: 700;
                        }

                        .radio-box {
                            margin: 6px 0 15px;

                            input[type="radio"] {
                                display: none;

                                &:checked + label::after {
                                    content: '';
                                    display: inline-block;
                                    position: absolute;
                                    left: 4px;
                                    top: 4px;
                                    width: 8px;
                                    height: 8px;
                                    margin-right: 8px;
                                    background-color: #2F353A;
                                    border-radius: 50%;
                                }
                            }

                            label {
                                position: relative;
                                display: flex;
                                margin: 0;

                                &::before {
                                    content: '';
                                    display: inline-block;
                                    width: 16px;
                                    height: 16px;
                                    border: 2px solid #2F353A;
                                    border-radius: 50%;
                                    margin-right: 8px;
                                }
                            }
                        }

                        select {
                            margin-bottom: 20px;
                            background: url("data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 8 4.2' style='enable-background:new 0 0 8 4.2;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%230088FF;%7D%0A%3C/style%3E%3Cpolygon class='st0' points='4,4.2 0,0 8,0 '/%3E%3C/svg%3E%0A") no-repeat right 0.75rem center/8px 10px #ffffff;
                        }

                        .mx-datepicker {
                            margin-bottom: 12px;
                        }

                        input[type="number"] {
                            padding: 8px 14px;
                            margin-bottom: 8px;
                            -webkit-border-radius: 4px;
                            -moz-border-radius: 4px;
                            border-radius: 4px;
                            border: 1px solid #C9CFD4;
                        }


                        &:last-child {
                            border: none;
                        }

                        &.type {
                            width: 180px;
                        }

                        &.amount {
                            width: 240px;
                        }

                        &.dates {
                            width: 240px;
                        }

                        .error-msg {
                            flex-grow: 1;
                            font-size: 12px;
                            color: #9f191f;
                        }
                    }
                }

                .control-bar {
                    .right-side {
                        .btn-light {
                            margin-right: 10px;
                        }
                    }
                }
            }
        }
    }

    #setThreshold___BV_modal_body_ {
        display: flex;
        flex-direction: column;
        align-items: center;

        .fa-credit-card {
            margin: 0 0 12px;
            font-size: 22px;
            color: #0088ff;
        }

        h3 {
            margin: 0 0 20px;
            font-size: 15px;
        }

        p {
            margin: 0 0 12px;
            font-size: 14px;
        }

        input {
            width: 120px;
            padding: 8px 19px;
            background-color: #f0f3f5;
            border: 1px solid #C9CFD4;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;
        }

        .buttons-row {
            display: flex;
            justify-content: center;
            margin-top: 20px;
            button {
                &:first-child {
                    margin-right: 10px;
                }
            }
        }
    }

    .dark-theme {
        .all-charges {
            .charges-info-box {
                .charges-box {
                    background-color: #2f353a;
                    border-color: #1a1c1d;
                }
            }

            .filter-row {
                border-color: #1a1c1d;
                .left-side {
                    input {
                        border-color: #1a1c1d;
                    }
                    .form-control {
                        background-color: #2f353a;
                        color: #fff;
                        &::placeholder {
                            color: #fff;
                        }
                    }
                }
                .text-right {
                    .custom-select {
                        background-color: #2f353a;
                        border-color: #1a1c1d;
                        color: #fff;
                    }
                }
            }


            .loader-charges-list,
            .no-charges {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;

                background-color: rgba(0, 0, 0, 0.4);
            }
        }

        #filters___BV_modal_outer_ {
            .modal-dialog {
                #filters___BV_modal_body_ {
                    .columns {
                        .column {
                            border-color: #1a1c1d;
                            select,
                            input[type="number"] {
                                background-color: #2f353a;
                                border-color: #1a1c1d;
                                color: #fff;
                                &::placeholder {
                                    color: #fff;
                                }
                            }
                            .radio-box {
                                label {
                                    &::before {
                                        border-color: #fff;
                                    }
                                }
                                input[type="radio"] {
                                    &:checked {
                                        &+label {
                                            &::after {
                                                background-color: #fff;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .control-bar {
                        border-color: #1a1c1d;
                    }
                }
            }
        }
        #setThreshold___BV_modal_body_ {
            input {
                background-color: #2f353a;
                border-color: #1a1c1d;
                color: #fff;
            }
        }
    }
</style>
